// ไฟล์: frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import authService from './services/auth';



// หน้าล็อกอิน
import Login from './pages/Login';

// หน้าของแอดมิน
import AdminDashboard from './pages/admin/Dashboard';
import AdminStudents from './pages/admin/Students';
import AdminClasses from './pages/admin/Classes';
import AdminTeachers from './pages/admin/Teachers';
import AdminProfile from './pages/admin/Profile';
import AdminTeacherWorks from './pages/admin/TeacherWorks';
import AdminTrainingCourses from './pages/admin/TrainingCourses';
import AdminTeacherTrainings from './pages/admin/TeacherTrainings';
import AdminSubjects from './pages/admin/Subjects'; // เพิ่มมาใหม่



// หน้าของครู
import TeacherDashboard from './pages/teacher/Dashboard';
import TeacherAttendance from './pages/teacher/Attendance';
import TeacherSavings from './pages/teacher/Savings';
import TeacherGrowth from './pages/teacher/Growth';
import TeacherReports from './pages/teacher/Reports';
import TeacherProfile from './pages/teacher/Profile';
import TeacherGrowthReports from './pages/teacher/GrowthReports';
import TeacherHealthRecords from './pages/teacher/HealthRecords';
import TeacherHealthReports from './pages/teacher/HealthReports';
import TeacherWorks from './pages/teacher/Works';
import TeacherPortfolios from './pages/teacher/Portfolios'; // เพิ่มบรรทัดนี้
import TeacherTrainings from './pages/teacher/Trainings';
import TeacherScores from './pages/teacher/Scores'; // เพิ่มมาใหม่
import TeacherScoreReports from './pages/teacher/ScoreReports'; // เพิ่มมาใหม่


// Protected Route Component
const ProtectedRoute = ({ element, requiredRole }) => {
  const isAuthenticated = authService.isAuthenticated();
  const currentUser = authService.getCurrentUser();
  
  // ถ้ายังไม่ล็อกอิน ให้ redirect ไปหน้าล็อกอิน
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // ถ้ามีการกำหนดบทบาทที่ต้องการ ตรวจสอบว่าตรงกับบทบาทของผู้ใช้หรือไม่
  if (requiredRole && currentUser.role !== requiredRole) {
    // ถ้าไม่ตรงให้ redirect ไปหน้าที่เหมาะสมกับบทบาท
    if (currentUser.role === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    }
    if (currentUser.role === 'teacher') {
      return <Navigate to="/teacher/dashboard" replace />;
    }
    return <Navigate to="/login" replace />;
  }
  
  
  // ถ้าผ่านเงื่อนไขทั้งหมด ให้แสดงหน้าที่ต้องการ
  return element;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* หน้าล็อกอิน */}
        <Route path="/login" element={<Login />} />
        
        {/* หน้าแรก (Redirect ตามบทบาท) */}
        <Route
          path="/"
          element={
            authService.isAuthenticated() ? (
              authService.isAdmin() ? (
                <Navigate to="/admin/dashboard" replace />
              ) : (
                <Navigate to="/teacher/dashboard" replace />
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        
        {/* หน้าของแอดมิน */}
        <Route path="/admin/dashboard" element={<ProtectedRoute element={<AdminDashboard />} requiredRole="admin" />} />
        <Route path="/admin/students" element={<ProtectedRoute element={<AdminStudents />} requiredRole="admin" />} />
        <Route path="/admin/classes" element={<ProtectedRoute element={<AdminClasses />} requiredRole="admin" />} />
        <Route path="/admin/teachers" element={<ProtectedRoute element={<AdminTeachers />} requiredRole="admin" />} />
        <Route path="/admin/teacher-works" element={<ProtectedRoute element={<AdminTeacherWorks />} requiredRole="admin" />} />
        <Route path="/admin/profile" element={<ProtectedRoute element={<AdminProfile />} requiredRole="admin" />} />
        {/* // เพิ่ม Routes สำหรับแอดมิน */}
<Route path="/admin/training-courses" element={<ProtectedRoute element={<AdminTrainingCourses />} requiredRole="admin" />} />
<Route path="/admin/teacher-trainings" element={<ProtectedRoute element={<AdminTeacherTrainings />} requiredRole="admin" />} />
<Route path="/admin/subjects" element={<ProtectedRoute element={<AdminSubjects />} requiredRole="admin" />} /> {/* เพิ่มมาใหม่ */}

        
        {/* หน้าของครู */}
        <Route path="/teacher/dashboard" element={<ProtectedRoute element={<TeacherDashboard />} requiredRole="teacher" />} />
        <Route path="/teacher/attendance" element={<ProtectedRoute element={<TeacherAttendance />} requiredRole="teacher" />} />
        <Route path="/teacher/growth" element={<ProtectedRoute element={<TeacherGrowth />} requiredRole="teacher" />} />
        <Route path="/teacher/growth/reports" element={<ProtectedRoute element={<TeacherGrowthReports />} requiredRole="teacher" />} />
        {/* // เพิ่ม routes สำหรับหน้าแปรงฟันและดื่มนม (ในส่วนของ Routes ของ Teacher) */}
        <Route path="/teacher/health-records" element={<ProtectedRoute element={<TeacherHealthRecords />} requiredRole="teacher" />} />
        <Route path="/teacher/health-reports" element={<ProtectedRoute element={<TeacherHealthReports />} requiredRole="teacher" />} />
        <Route path="/teacher/portfolios" element={<ProtectedRoute element={<TeacherPortfolios />} requiredRole="teacher" />} /> {/* เพิ่มบรรทัดนี้ */}
        <Route path="/teacher/savings" element={<ProtectedRoute element={<TeacherSavings />} requiredRole="teacher" />} />
        <Route path="/teacher/reports" element={<ProtectedRoute element={<TeacherReports />} requiredRole="teacher" />} />
        <Route path="/teacher/works" element={<ProtectedRoute element={<TeacherWorks />} requiredRole="teacher" />} />
        <Route path="/teacher/profile" element={<ProtectedRoute element={<TeacherProfile />} requiredRole="teacher" />} />
        {/* // เพิ่ม Routes สำหรับครู */}
<Route path="/teacher/trainings" element={<ProtectedRoute element={<TeacherTrainings />} requiredRole="teacher" />} />
<Route path="/teacher/scores" element={<ProtectedRoute element={<TeacherScores />} requiredRole="teacher" />} /> {/* เพิ่มมาใหม่ */}
<Route path="/teacher/score-reports" element={<ProtectedRoute element={<TeacherScoreReports />} requiredRole="teacher" />} /> {/* เพิ่มมาใหม่ */}

        
        {/* หน้าที่ไม่พบ */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;